import { render } from "./departmentModel.vue?vue&type=template&id=6624c528"
import script from "./departmentModel.vue?vue&type=script&lang=js"
export * from "./departmentModel.vue?vue&type=script&lang=js"

import "./departmentModel.vue?vue&type=style&index=0&id=6624c528&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__